import React from 'react'
import Spacer from '../spacer'
import HorizontalRule from '../horizontal-rule'
import css from './style.css'
import HeaderSection from './header-section'
import BodySection from './body-section'
import PaginationFooter from './pagination-footer'

const SearchResults = () => {
  return (
    <div className={css.searchResultDiv}>
      <HorizontalRule>Search Results</HorizontalRule>
      <HeaderSection />
      <BodySection />
      <Spacer xs />
      <PaginationFooter />
    </div>
  )
}

export default SearchResults



// WEBPACK FOOTER //
// ./src/components/search-results/index.js